var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMultiChoice = function SvgMultiChoice(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 134,
    viewBox: "0 0 154 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2737_94123)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2737_94123",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 9.23858 9.23858 7 12 7H142C144.761 7 147 9.23858 147 12V122C147 124.761 144.761 127 142 127H12C9.23857 127 7 124.761 7 122V12Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 9.23858 9.23858 7 12 7H142C144.761 7 147 9.23858 147 12V122C147 124.761 144.761 127 142 127H12C9.23857 127 7 124.761 7 122V12Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 27,
    width: 124,
    height: 14,
    rx: 1.57895,
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 34,
    x2: 132,
    y2: 34,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 50,
    width: 105,
    height: 14,
    rx: 1.57895,
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 57,
    x2: 113,
    y2: 57,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 56.3333L131 58.3333L137.667 51.6667",
    stroke: "#343A40",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 57V61.6667C137 62.0203 136.86 62.3594 136.609 62.6095C136.359 62.8595 136.02 63 135.667 63H126.333C125.98 63 125.641 62.8595 125.391 62.6095C125.14 62.3594 125 62.0203 125 61.6667V52.3333C125 51.9797 125.14 51.6406 125.391 51.3905C125.641 51.1405 125.98 51 126.333 51H133.667",
    stroke: "#4C6EF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 74,
    width: 105,
    height: 14,
    rx: 1.57895,
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 81,
    x2: 113,
    y2: 81,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 81V85.6667C137 86.0203 136.86 86.3594 136.609 86.6095C136.359 86.8595 136.02 87 135.667 87H126.333C125.98 87 125.641 86.8595 125.391 86.6095C125.14 86.3594 125 86.0203 125 85.6667V76.3333C125 75.9797 125.14 75.6406 125.391 75.3905C125.641 75.1405 125.98 75 126.333 75H133.667",
    stroke: "#4C6EF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 98,
    width: 105,
    height: 14,
    rx: 1.57895,
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 105,
    x2: 113,
    y2: 105,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 104.333L131 106.333L137.667 99.6667",
    stroke: "#343A40",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 105V109.667C137 110.02 136.86 110.359 136.609 110.609C136.359 110.86 136.02 111 135.667 111H126.333C125.98 111 125.641 110.86 125.391 110.609C125.14 110.359 125 110.02 125 109.667V100.333C125 99.9797 125.14 99.6406 125.391 99.3905C125.641 99.1405 125.98 99 126.333 99H133.667",
    stroke: "#4C6EF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 2.61116 14.6112 -5 24 -5H130C139.389 -5 147 2.61116 147 12V19C147 19 144.761 19 142 19H12C9.23858 19 7 19 7 19V12ZM147 127H7H147ZM7 127V7V127ZM147 7V127V7Z",
    fill: "#343A40",
    mask: "url(#path-1-inside-1_2737_94123)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2737_94123",
    x: 0,
    y: 0,
    width: 154,
    height: 134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.364706 0 0 0 0 0.494118 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2737_94123"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2737_94123",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMultiChoice);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";